import {RestApiService} from '../../../rest-api.service';
import {ToDoCreateReq, TodoDetailRes, ToDoGroupCreateReq, ToDoGroupRes} from '../../../../contracts/v0/crm';
import {ApiV0Crm} from '../api.v0.crm';
import {Observable} from 'rxjs';
import {BaseCollectionModel, SearchModel} from '@yasc/yasc-material-components';

// TODO: YASCCP-570
export class ApiV0CrmTodo {
    segment = '/todo'

    constructor(v0: ApiV0Crm, private rest: RestApiService) {
        this.segment = v0.segment + this.segment;
    }
    search(searchModel:SearchModel = new SearchModel({})):Observable<BaseCollectionModel<TodoDetailRes>>{
        return this.rest.post<SearchModel, BaseCollectionModel<TodoDetailRes>>(`${this.segment}/search`, TodoDetailRes,searchModel)
    }
    create(creatReq: ToDoCreateReq) {
        return this.rest.post<ToDoCreateReq, TodoDetailRes>(`${this.segment}/create`, TodoDetailRes, creatReq)
    }

    group() {
        return this.rest.get<BaseCollectionModel<ToDoGroupRes>>(`${this.segment}/group`, BaseCollectionModel<ToDoGroupRes>)
    }

    createGroup(createReq: ToDoGroupCreateReq) {
        return this.rest.post<ToDoGroupCreateReq, ToDoGroupRes>(`${this.segment}/group/create`, ToDoGroupRes, createReq)
    }
}
